var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgNodata(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 411.673,
    height: 303.181,
    viewBox: "0 0 411.673 303.181",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "No_data-pana_1_",
    "data-name": "No data-pana (1)",
    transform: "translate(-86.33)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--background-complete--inject-1",
    transform: "translate(100.943)",
    opacity: 0.107
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3636",
    "data-name": "Rectangle 3636",
    width: 92.38,
    height: 136.028,
    transform: "translate(0 135.033) rotate(-33.78)",
    fill: "#f5f5f5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10631",
    "data-name": "Path 10631",
    d: "M254.412,277.122l-.869,5.393-38.173-5.5.869-5.393Z",
    transform: "translate(-141.675 -85.738)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10632",
    "data-name": "Path 10632",
    d: "M241.527,251.55l5.475.787-6.07,37.584-5.482-.794Z",
    transform: "translate(-148.013 -79.402)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10633",
    "data-name": "Path 10633",
    d: "M177.056,181.75c.055.075-7.637,5.324-17.184,11.7s-17.328,11.5-17.382,11.415,7.637-5.324,17.184-11.709S176.967,181.667,177.056,181.75Z",
    transform: "translate(-118.67 -57.369)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10634",
    "data-name": "Path 10634",
    d: "M207.762,171.39c.055.082-12.743,8.732-28.578,19.326s-28.743,19.114-28.784,19.039,12.729-8.739,28.585-19.333S207.707,171.308,207.762,171.39Z",
    transform: "translate(-121.167 -54.099)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10635",
    "data-name": "Path 10635",
    d: "M216.032,183.75c.055.082-12.743,8.739-28.578,19.333S158.711,222.2,158.67,222.114s12.743-8.732,28.585-19.333S215.977,183.668,216.032,183.75Z",
    transform: "translate(-123.777 -58.001)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10636",
    "data-name": "Path 10636",
    d: "M224.321,196.12c.055.082-12.743,8.739-28.578,19.326S167,234.566,167,234.484s12.736-8.739,28.578-19.333S224.266,196.038,224.321,196.12Z",
    transform: "translate(-126.407 -61.906)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10637",
    "data-name": "Path 10637",
    d: "M232.545,208.49c.055.082-12.743,8.732-28.578,19.326s-28.743,19.114-28.777,19.032,12.756-8.732,28.613-19.326S232.545,208.408,232.545,208.49Z",
    transform: "translate(-128.992 -65.81)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3637",
    "data-name": "Rectangle 3637",
    width: 77.584,
    height: 114.238,
    transform: "translate(269.056 202.565) rotate(-33.78)",
    fill: "#f5f5f5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10638",
    "data-name": "Path 10638",
    d: "M624.074,363.049l-.732,4.53L591.28,362.96l.739-4.53Z",
    transform: "translate(-260.332 -113.139)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10639",
    "data-name": "Path 10639",
    d: "M613.255,341.57l4.6.664-5.1,31.562-4.606-.664Z",
    transform: "translate(-265.657 -107.818)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10640",
    "data-name": "Path 10640",
    d: "M559.067,283c.055.082-6.4,4.5-14.419,9.855s-14.563,9.642-14.618,9.581,6.406-4.489,14.419-9.855S559.012,282.883,559.067,283Z",
    transform: "translate(-240.998 -89.329)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10641",
    "data-name": "Path 10641",
    d: "M584.907,274.25c.055.082-10.683,7.364-23.952,16.253s-24.13,16.048-24.185,15.966,10.683-7.364,23.952-16.26S584.832,274.168,584.907,274.25Z",
    transform: "translate(-243.126 -86.567)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10642",
    "data-name": "Path 10642",
    d: "M591.857,284.63c.055.082-10.683,7.364-23.952,16.26s-24.13,16.041-24.185,15.959,10.648-7.329,23.952-16.226S591.816,284.554,591.857,284.63Z",
    transform: "translate(-245.319 -89.844)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10643",
    "data-name": "Path 10643",
    d: "M598.8,295c.055.082-10.69,7.364-23.952,16.26s-24.13,16.041-24.185,15.959,10.683-7.357,23.952-16.26S598.749,294.931,598.8,295Z",
    transform: "translate(-247.51 -93.117)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10644",
    "data-name": "Path 10644",
    d: "M605.8,305.41c.055.082-10.683,7.357-23.952,16.253s-24.13,16.041-24.185,15.966,10.683-7.364,23.952-16.26S605.708,305.328,605.8,305.41Z",
    transform: "translate(-249.719 -96.403)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3638",
    "data-name": "Rectangle 3638",
    width: 79.795,
    height: 117.496,
    transform: "translate(161.158 50.196) rotate(28.14)",
    fill: "#f5f5f5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10645",
    "data-name": "Path 10645",
    d: "M340.135,217.919l-4.462,1.526L324.34,188.123l4.469-1.533Z",
    transform: "translate(-176.071 -58.898)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10646",
    "data-name": "Path 10646",
    d: "M343.07,199.53l1.629,4.5-31.11,10.655-1.629-4.5Z",
    transform: "translate(-172.164 -62.982)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10647",
    "data-name": "Path 10647",
    d: "M375.108,124.187c-.055.1-7.186-3.607-15.938-8.281s-15.795-8.554-15.74-8.657,7.193,3.606,15.945,8.281S375.163,124.077,375.108,124.187Z",
    transform: "translate(-182.097 -33.853)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10648",
    "data-name": "Path 10648",
    d: "M390.158,146.262c-.055.1-11.867-6.111-26.382-13.872s-26.231-14.139-26.176-14.241,11.86,6.1,26.375,13.872S390.213,146.16,390.158,146.262Z",
    transform: "translate(-180.257 -37.294)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10649",
    "data-name": "Path 10649",
    d: "M384.1,157.592c-.055.1-11.867-6.1-26.382-13.872s-26.231-14.139-26.176-14.241,11.86,6.111,26.375,13.872S384.153,157.49,384.1,157.592Z",
    transform: "translate(-178.344 -40.87)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10650",
    "data-name": "Path 10650",
    d: "M378.038,168.925c-.055.1-11.867-6.1-26.382-13.865s-26.231-14.118-26.176-14.241,11.86,6.1,26.375,13.865S378.092,168.823,378.038,168.925Z",
    transform: "translate(-176.431 -44.449)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10651",
    "data-name": "Path 10651",
    d: "M371.978,180.256c-.055.1-11.867-6.1-26.382-13.865s-26.238-14.139-26.176-14.241,11.86,6.1,26.375,13.865S372.033,180.153,371.978,180.256Z",
    transform: "translate(-174.518 -48.026)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3639",
    "data-name": "Rectangle 3639",
    width: 1.766,
    height: 30.098,
    transform: "translate(196.056)",
    opacity: 0.2
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Lamp--inject-1",
    transform: "translate(256.664)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_10652",
    "data-name": "Path 10652",
    d: "M335.23,80.4h82.436S410.057,44,375.825,44C345.379,44,335.23,80.4,335.23,80.4Z",
    transform: "translate(-335.23 -13.889)",
    fill: "#4eb6ee"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3640",
    "data-name": "Rectangle 3640",
    width: 1.766,
    height: 30.098,
    transform: "translate(40.335)",
    fill: "#4eb6ee"
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Floor--inject-1",
    transform: "translate(86.33 300.818)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_10653",
    "data-name": "Path 10653",
    d: "M481.431,439.748c0,.1-88.452.178-197.544.178s-197.557-.062-197.557-.178,88.438-.178,197.557-.178S481.431,439.645,481.431,439.748Z",
    transform: "translate(-86.33 -439.57)",
    fill: "#263238"
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Plant--inject-1",
    transform: "translate(100.94 258.129)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_10654",
    "data-name": "Path 10654",
    d: "M117.115,377.2a8.636,8.636,0,0,1,6.009,3.08,15.158,15.158,0,0,1,3.059,6.159c1.157,4.325.445,9.437-.787,13.742-4.681-1.677-7.576-6.672-8.9-9.3-2.053-4.147-3.278-12.907.6-13.687",
    transform: "translate(-109.853 -377.19)",
    fill: "#4eb6ee"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10655",
    "data-name": "Path 10655",
    d: "M139.7,412.728a7.35,7.35,0,0,1-.342-7.377,9.759,9.759,0,0,1,5.885-4.729,4.1,4.1,0,0,1,3.463.164,3.134,3.134,0,0,1,1.211,2.949,6.344,6.344,0,0,1-1.369,3.025c-2.279,3.086-5.044,5.653-8.9,5.968",
    transform: "translate(-117.416 -384.491)",
    fill: "#4eb6ee"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10656",
    "data-name": "Path 10656",
    d: "M140.385,429.6a4.448,4.448,0,0,1-.212-.9c-.123-.643-.287-1.471-.486-2.464a25.848,25.848,0,0,1-.506-8.287,15.74,15.74,0,0,1,3.073-7.672,10.484,10.484,0,0,1,1.772-1.8,6.273,6.273,0,0,1,.561-.4.786.786,0,0,1,.205-.123,17.36,17.36,0,0,0-2.361,2.457A16.322,16.322,0,0,0,139.5,418a27.825,27.825,0,0,0,.417,8.212c.164,1.047.3,1.9.376,2.484A5.63,5.63,0,0,1,140.385,429.6Z",
    transform: "translate(-117.581 -386.903)",
    fill: "#4eb6ee"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10657",
    "data-name": "Path 10657",
    d: "M120.49,386.83a1.6,1.6,0,0,1,.192.349c.123.274.287.616.479,1.047.417.91,1,2.231,1.7,3.867,1.41,3.278,3.3,7.836,5.269,12.914s3.648,9.711,4.79,13.085c.589,1.684,1.047,3.052,1.369,4,.144.452.253.814.342,1.1a1.788,1.788,0,0,1,.1.39,1.684,1.684,0,0,1-.164-.37c-.1-.274-.233-.63-.4-1.074l-1.444-3.969c-1.225-3.346-2.936-7.973-4.9-13.044s-3.826-9.642-5.181-12.941c-.684-1.622-1.211-2.943-1.6-3.908-.178-.438-.322-.787-.431-1.068A2.388,2.388,0,0,1,120.49,386.83Z",
    transform: "translate(-111.722 -380.233)",
    fill: "#4eb6ee"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10658",
    "data-name": "Path 10658",
    d: "M124.918,421.762a17.232,17.232,0,0,0-13.358-8.3c-1.369-.1-3.052.137-3.668,1.369s.205,2.737,1.15,3.737a14.707,14.707,0,0,0,15.925,3.559",
    transform: "translate(-107.678 -388.633)",
    fill: "#4eb6ee"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10659",
    "data-name": "Path 10659",
    d: "M116.43,418.887a4.887,4.887,0,0,1,.869.034,8.269,8.269,0,0,1,1.006.116c.39.075.849.116,1.328.253a13.286,13.286,0,0,1,1.581.438,15.68,15.68,0,0,1,1.759.684,19.024,19.024,0,0,1,3.709,2.2,18.689,18.689,0,0,1,3.066,3.038,15.4,15.4,0,0,1,1.074,1.54,15.005,15.005,0,0,1,.808,1.43,11.9,11.9,0,0,1,.547,1.232,7.768,7.768,0,0,1,.349.958,4.67,4.67,0,0,1,.226.842c-.075,0-.4-1.177-1.328-2.929a15.034,15.034,0,0,0-.828-1.369,17.323,17.323,0,0,0-1.081-1.5,18.237,18.237,0,0,0-6.666-5.146c-.6-.26-1.163-.506-1.718-.684a14.968,14.968,0,0,0-1.553-.472C117.662,419.024,116.423,418.962,116.43,418.887Z",
    transform: "translate(-110.441 -390.35)",
    fill: "#4eb6ee"
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Character--inject-1",
    transform: "translate(362.779 46.536)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_10660",
    "data-name": "Path 10660",
    d: "M565.631,104.823c-2.012.459-2.991,2.778-3.182,4.831s.068,4.229-.794,6.1c-.972,2.108-3.292,3.668-3.367,5.988-.048,1.417.794,2.737.753,4.168-.068,2.327-2.436,4.106-2.566,6.405-.089,1.677,1.027,3.278.76,4.934-.205,1.287-1.211,2.3-1.636,3.531-.842,2.464.849,5.167,3.045,6.549a9.985,9.985,0,0,0,14.542-4.64c1.218-2.956.951-6.289.684-9.471q-1.232-14.891-1.834-29.824",
    transform: "translate(-510.835 -79.174)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10661",
    "data-name": "Path 10661",
    d: "M561.82,140.852a2.334,2.334,0,0,0,.924-1.088,3.962,3.962,0,0,0,.233-1.677,9.213,9.213,0,0,0-.5-2.21,6.371,6.371,0,0,1-.356-2.806,6.447,6.447,0,0,1,1.629-2.806,6.006,6.006,0,0,0,.924-1.4,2.266,2.266,0,0,0,.109-1.642c-.356-1.116-1.451-1.937-1.95-3.23a3.42,3.42,0,0,1-.109-2,7.926,7.926,0,0,1,.684-1.786,15.332,15.332,0,0,0,1.369-3.223c.479-2.169.253-4.243.582-5.947a6.583,6.583,0,0,1,1.731-3.641,3.977,3.977,0,0,1,.9-.684,1.415,1.415,0,0,1,.363-.13,5.263,5.263,0,0,0-1.17.876,6.693,6.693,0,0,0-1.581,3.593,22.28,22.28,0,0,0-.192,2.737A16.853,16.853,0,0,1,565.1,117a15.382,15.382,0,0,1-1.369,3.3,4.517,4.517,0,0,0-.534,3.511c.452,1.177,1.54,1.991,1.957,3.251a2.656,2.656,0,0,1-.13,1.882,6.479,6.479,0,0,1-1.027,1.54,6.494,6.494,0,0,0-1.594,2.642,6.159,6.159,0,0,0,.315,2.689,9.317,9.317,0,0,1,.452,2.272,3.839,3.839,0,0,1-.308,1.738,2.094,2.094,0,0,1-.684.862A1.081,1.081,0,0,1,561.82,140.852Z",
    transform: "translate(-512.869 -80.178)",
    fill: "#455a64"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10662",
    "data-name": "Path 10662",
    d: "M537.3,180.37l-6.159,17.793-25.759,1.369-4.3,9.581,26.895,2.737a10.163,10.163,0,0,0,13.427-5.974l7.179-20.038Z",
    transform: "translate(-493.696 -103.47)",
    fill: "#e2b7a6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10663",
    "data-name": "Path 10663",
    d: "M609.733,371.263s-18.874-59.962-19.278-61.906c-.363-1.766,6.844-44.914,7.761-56.116l-25.506.951v.253l-10.84.6,9.7,122.58h11.737l-1.163-40.684a396.794,396.794,0,0,0,17.615,39.234Z",
    transform: "translate(-512.884 -126.472)",
    fill: "#e2b7a6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10664",
    "data-name": "Path 10664",
    d: "M590.106,384.937c0-.37-.144-13.632-.144-13.632-.144.794-4.5-11.511-4.393-12.257C585.624,358.658,590.106,384.937,590.106,384.937Z",
    transform: "translate(-520.365 -159.869)",
    fill: "#d7a897"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10665",
    "data-name": "Path 10665",
    d: "M584.8,350.53a2.653,2.653,0,0,0-.075.746,18.578,18.578,0,0,0,0,2.053,13.649,13.649,0,0,0,.116,1.4c.055.506.13,1.04.246,1.594a28.317,28.317,0,0,0,.965,3.572c.849,2.484,1.793,4.654,2.457,6.228.315.684.589,1.335.821,1.855a2.956,2.956,0,0,0,.342.684,2.6,2.6,0,0,0-.205-.684c-.157-.452-.4-1.1-.684-1.9-.6-1.6-1.506-3.791-2.347-6.248a29.658,29.658,0,0,1-.979-3.517c-.123-.548-.205-1.075-.28-1.567s-.13-.958-.164-1.369c-.082-.849-.116-1.533-.137-2.012a3.093,3.093,0,0,0-.075-.835Z",
    transform: "translate(-520.09 -157.181)",
    fill: "#d7a897"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10666",
    "data-name": "Path 10666",
    d: "M572.007,435.159v-1.1l12.024-.527.034,4.551-.739.048c-3.305.192-16.8.753-19,.089C561.851,437.479,572.007,435.159,572.007,435.159Z",
    transform: "translate(-513.536 -183.381)",
    fill: "#455a64"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10667",
    "data-name": "Path 10667",
    d: "M584.218,439.78a1.557,1.557,0,0,1-.205,0l-.589.041-2.176.1c-1.834.075-4.373.144-7.172.157s-5.345-.034-7.186-.089l-2.169-.089h-.8a1.267,1.267,0,0,1,.205,0h.6l2.176.041c1.834,0,4.373.055,7.172.041s5.345-.062,7.179-.109l2.176-.055h.794Z",
    transform: "translate(-513.531 -185.353)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10668",
    "data-name": "Path 10668",
    d: "M569.466,439.481a5.245,5.245,0,0,0-.411-1.033,4.934,4.934,0,0,0-.746-.828,1.587,1.587,0,0,1,.869.753A1.636,1.636,0,0,1,569.466,439.481Z",
    transform: "translate(-514.917 -184.672)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10669",
    "data-name": "Path 10669",
    d: "M574.887,437.252a2.708,2.708,0,0,1-.376-.459c-.178-.274-.287-.513-.253-.534s.2.178.376.452S574.921,437.231,574.887,437.252Z",
    transform: "translate(-516.792 -184.242)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10670",
    "data-name": "Path 10670",
    d: "M576.251,436.692c0,.034-.219-.1-.424-.281s-.356-.356-.329-.383.219.1.424.281S576.279,436.63,576.251,436.692Z",
    transform: "translate(-517.185 -184.168)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10671",
    "data-name": "Path 10671",
    d: "M576.912,435.266a1.444,1.444,0,0,1-.63.082,1.369,1.369,0,0,1-.623-.062,1.424,1.424,0,0,1,.623-.082A1.367,1.367,0,0,1,576.912,435.266Z",
    transform: "translate(-517.237 -183.905)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10672",
    "data-name": "Path 10672",
    d: "M577.159,434.14a1.272,1.272,0,0,1-.684.205,1.294,1.294,0,0,1-.684-.1,3.944,3.944,0,0,1,.684-.055A3.552,3.552,0,0,1,577.159,434.14Z",
    transform: "translate(-517.278 -183.573)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10673",
    "data-name": "Path 10673",
    d: "M573.548,435.691a2.1,2.1,0,0,1-.773,0,4.414,4.414,0,0,1-.814-.178,2.21,2.21,0,0,1-.472-.192.431.431,0,0,1-.192-.24.3.3,0,0,1,.116-.308,1.423,1.423,0,0,1,2,.924.52.52,0,0,1,0,.205,2.2,2.2,0,0,0-.356-.684,1.41,1.41,0,0,0-.684-.424,1.218,1.218,0,0,0-.917.068c-.116.089-.068.233.062.315a2.471,2.471,0,0,0,.438.185,5.759,5.759,0,0,0,.787.2C573.254,435.671,573.548,435.671,573.548,435.691Z",
    transform: "translate(-515.858 -183.728)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10674",
    "data-name": "Path 10674",
    d: "M574.249,435.552a.725.725,0,0,1-.1-.534,1.272,1.272,0,0,1,.212-.561.78.78,0,0,1,.636-.4.315.315,0,0,1,.24.356.814.814,0,0,1-.13.342,2.823,2.823,0,0,1-.363.472,1.122,1.122,0,0,1-.438.308,4.829,4.829,0,0,0,.363-.383,2.66,2.66,0,0,0,.322-.459c.1-.164.178-.458,0-.493s-.383.178-.5.328a1.25,1.25,0,0,0-.219.5,2.409,2.409,0,0,0-.027.52Z",
    transform: "translate(-516.757 -183.548)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10675",
    "data-name": "Path 10675",
    d: "M591.254,434.962s-.342,0-.883.034a3.791,3.791,0,0,0-3.128,2.512c-.178.513-.192.862-.219.855s0-.089,0-.24a3.075,3.075,0,0,1,.123-.65,3.743,3.743,0,0,1,1.2-1.786,3.688,3.688,0,0,1,2.005-.787,2.871,2.871,0,0,1,.684,0A.867.867,0,0,1,591.254,434.962Z",
    transform: "translate(-520.821 -183.807)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10676",
    "data-name": "Path 10676",
    d: "M583.187,438.373a6.71,6.71,0,0,1-1.752.171,6.455,6.455,0,0,1-1.745-.151c0-.041.78,0,1.745,0S583.18,438.332,583.187,438.373Z",
    transform: "translate(-518.509 -184.905)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10677",
    "data-name": "Path 10677",
    d: "M588.062,438.347s-.062.164-.144.342-.123.342-.164.335-.062-.185.034-.4S588.035,438.313,588.062,438.347Z",
    transform: "translate(-521.044 -184.899)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10678",
    "data-name": "Path 10678",
    d: "M589.3,436.736a.76.76,0,0,1-.171.274c-.123.123-.246.205-.281.178s.048-.151.171-.281S589.264,436.7,589.3,436.736Z",
    transform: "translate(-521.397 -184.39)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10679",
    "data-name": "Path 10679",
    d: "M591.034,435.969c0,.041-.164.041-.342.1s-.3.157-.335.13.068-.192.287-.267S591.048,435.928,591.034,435.969Z",
    transform: "translate(-521.874 -184.129)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10680",
    "data-name": "Path 10680",
    d: "M592.5,435.628c0,.041-.048.1-.151.137s-.192.041-.205,0,.055-.1.151-.137S592.481,435.594,592.5,435.628Z",
    transform: "translate(-522.438 -184.035)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10681",
    "data-name": "Path 10681",
    d: "M614,431.405l-.452-1.006L624.3,425l1.9,4.106-.684.349c-2.936,1.526-15.015,7.562-17.3,7.863C605.685,437.681,614,431.405,614,431.405Z",
    transform: "translate(-527.361 -180.688)",
    fill: "#455a64"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10682",
    "data-name": "Path 10682",
    d: "M626.244,430.57l-.178.11-.527.274-1.944.985c-1.642.814-3.928,1.916-6.481,3.08s-4.893,2.156-6.59,2.861l-2.019.814-.547.212a.779.779,0,0,1-.2.062l.185-.089.541-.24,2-.855c1.69-.725,4.017-1.738,6.57-2.9s4.845-2.245,6.5-3.039l1.957-.938.541-.253Z",
    transform: "translate(-527.37 -182.446)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10683",
    "data-name": "Path 10683",
    d: "M612.68,440.172a5.045,5.045,0,0,0-.8-.78,4.75,4.75,0,0,0-1.02-.452,1.923,1.923,0,0,1,1.82,1.232Z",
    transform: "translate(-528.348 -185.088)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10684",
    "data-name": "Path 10684",
    d: "M616.675,435.921a2.452,2.452,0,0,1-.534-.26c-.274-.178-.472-.349-.452-.383s.26.082.534.26S616.7,435.886,616.675,435.921Z",
    transform: "translate(-529.872 -183.93)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10685",
    "data-name": "Path 10685",
    d: "M617.668,434.856c0,.034-.233,0-.5-.082s-.465-.185-.458-.226a1.019,1.019,0,0,1,.506.082C617.476,434.692,617.682,434.787,617.668,434.856Z",
    transform: "translate(-530.195 -183.7)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10686",
    "data-name": "Path 10686",
    d: "M617.726,433.08a1.6,1.6,0,0,1-.541.335,1.443,1.443,0,0,1-.6.2,1.613,1.613,0,0,1,.534-.335A1.492,1.492,0,0,1,617.726,433.08Z",
    transform: "translate(-530.157 -183.238)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10687",
    "data-name": "Path 10687",
    d: "M617.479,431.9a1.864,1.864,0,0,1-.554.472,1.19,1.19,0,0,1-.684.205,3.612,3.612,0,0,1,.623-.335C617.2,432.056,617.444,431.864,617.479,431.9Z",
    transform: "translate(-530.046 -182.864)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10688",
    "data-name": "Path 10688",
    d: "M614.923,434.853a2.219,2.219,0,0,1-.684.315,5.367,5.367,0,0,1-.821.171,2.056,2.056,0,0,1-.506,0,.4.4,0,0,1-.274-.137.3.3,0,0,1,0-.328,1.41,1.41,0,0,1,1.759-.342,1.368,1.368,0,0,1,.438.363c.082.109.116.178.109.185a2.054,2.054,0,0,0-.6-.459,1.369,1.369,0,0,0-.773-.116,1.2,1.2,0,0,0-.807.438c-.075.13,0,.24.185.26a2.736,2.736,0,0,0,.472,0,5.407,5.407,0,0,0,.807-.144C614.622,434.949,614.923,434.833,614.923,434.853Z",
    transform: "translate(-528.894 -183.643)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10689",
    "data-name": "Path 10689",
    d: "M615.554,434.477a.759.759,0,0,1-.3-.452,1.287,1.287,0,0,1-.041-.6.773.773,0,0,1,.424-.623c.171-.055.568.294.6.424s-.2.062-.212.171a2.381,2.381,0,0,1-.137.568,1.068,1.068,0,0,1-.274.465,5.015,5.015,0,0,0,.178-.493,3.492,3.492,0,0,0,.1-.554c0-.192,0-.486-.219-.438s-.28.315-.328.506a1.183,1.183,0,0,0,0,.541A2.985,2.985,0,0,0,615.554,434.477Z",
    transform: "translate(-529.716 -183.151)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10690",
    "data-name": "Path 10690",
    d: "M631.2,426.36a4.853,4.853,0,0,0-.794.4,3.729,3.729,0,0,0-1.82,3.572c.041.547.171.862.144.876a.867.867,0,0,1-.1-.219,3.547,3.547,0,0,1-.144-.643,3.62,3.62,0,0,1,1.868-3.668,3.254,3.254,0,0,1,.609-.26A.841.841,0,0,1,631.2,426.36Z",
    transform: "translate(-533.901 -181.117)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10691",
    "data-name": "Path 10691",
    d: "M624.712,432.9a9.771,9.771,0,0,1-3.182,1.451c0-.041.719-.315,1.594-.684S624.692,432.865,624.712,432.9Z",
    transform: "translate(-531.716 -183.181)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10692",
    "data-name": "Path 10692",
    d: "M629.227,431.469c.034,0,0,.171,0,.37v.376a.559.559,0,0,1-.137-.376C629.09,431.613,629.193,431.449,629.227,431.469Z",
    transform: "translate(-534.103 -182.729)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10693",
    "data-name": "Path 10693",
    d: "M629.693,429.47c.034,0,0,.157-.041.322s-.144.287-.178.274,0-.157.041-.322S629.651,429.456,629.693,429.47Z",
    transform: "translate(-534.219 -182.099)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10694",
    "data-name": "Path 10694",
    d: "M630.934,428c0,.041-.137.1-.274.233s-.212.267-.246.253,0-.205.15-.363A.449.449,0,0,1,630.934,428Z",
    transform: "translate(-534.517 -181.634)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10695",
    "data-name": "Path 10695",
    d: "M632.1,427.176a.274.274,0,0,1-.082.185c-.082.075-.157.116-.185.089s0-.109.082-.185S632.075,427.149,632.1,427.176Z",
    transform: "translate(-534.966 -181.372)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10696",
    "data-name": "Path 10696",
    d: "M591.209,201.529l-2-24.431,10.265.185s.472-3.607-1.04-11.5c-.931-4.845-4.154-7.815-7.774-9.581v-.068l-.315-.082a29.309,29.309,0,0,0-9.417-2.457l-12.626.144s-9.642-1.232-14.96,5.673c-2.053,2.648-8.424,20.777-8.424,20.777l15.158,7.3-1.417-10.053s.287,7.288,1.218,9.581c.513,1.287,2.053,5.283,2.053,5.283l-.2,12.058Z",
    transform: "translate(-507.534 -95.017)",
    fill: "#4eb6ee"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10697",
    "data-name": "Path 10697",
    d: "M601.525,180.266l-1.875,7.979h17.677l-1.163-13.386Z",
    transform: "translate(-524.81 -101.731)",
    fill: "#5e98ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10698",
    "data-name": "Path 10698",
    d: "M618.094,194.246a14.166,14.166,0,0,0-2.341-.233c-1.451-.082-3.422-.157-5.666-.144s-4.222.109-5.673.219a13.415,13.415,0,0,0-2.334.287,14.831,14.831,0,0,0,2.354,0c1.444-.048,3.422-.1,5.653-.11s4.209,0,5.66.034A14.811,14.811,0,0,0,618.094,194.246Z",
    transform: "translate(-525.577 -107.73)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10699",
    "data-name": "Path 10699",
    d: "M601.233,174.77a10.666,10.666,0,0,0-.055,2.053c0,1.252.055,2.977.13,4.886s.164,3.641.246,4.886a10.184,10.184,0,0,0,.219,2.053,10.705,10.705,0,0,0,.055-2.053c0-1.252-.055-2.984-.13-4.893s-.164-3.634-.246-4.886A10.064,10.064,0,0,0,601.233,174.77Z",
    transform: "translate(-525.284 -101.702)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_2517",
    "data-name": "Group 2517",
    transform: "translate(59.867 79.98)",
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_10700",
    "data-name": "Path 10700",
    d: "M577.77,184.87S581.7,214,592.743,213.229c0,0,4.975-.055,6.57-3.36v-1.3Z",
    transform: "translate(-577.77 -184.87)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_2518",
    "data-name": "Group 2518",
    transform: "translate(73.834 74.785)",
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_10701",
    "data-name": "Path 10701",
    d: "M600.295,177.28l-2.115,14.282,1.369,2.5,2.258-4.9-.958-.027Z",
    transform: "translate(-598.18 -177.28)"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_10702",
    "data-name": "Path 10702",
    d: "M568.049,201.634a2.736,2.736,0,0,1-.3-.684c-.171-.445-.4-1.095-.684-1.909a58.949,58.949,0,0,1-1.69-6.467,45.853,45.853,0,0,1-.835-6.631c-.041-.855-.055-1.547-.041-2.053a2.735,2.735,0,0,1,.048-.739c.055,0,.1,1.054.24,2.737a60.912,60.912,0,0,0,.938,6.577c.506,2.546,1.116,4.825,1.581,6.46.219.76.4,1.41.554,1.944a3.346,3.346,0,0,1,.192.766Z",
    transform: "translate(-513.711 -104.347)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10703",
    "data-name": "Path 10703",
    d: "M575.8,221.064a3.533,3.533,0,0,1-.609-1.369,3.285,3.285,0,0,1-.267-1.506,3.573,3.573,0,0,1,.609,1.4A3.421,3.421,0,0,1,575.8,221.064Z",
    transform: "translate(-517.004 -115.408)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10704",
    "data-name": "Path 10704",
    d: "M578.253,220.26a6.3,6.3,0,0,1-.062-4.27,14.239,14.239,0,0,1,0,2.135A14.069,14.069,0,0,1,578.253,220.26Z",
    transform: "translate(-517.928 -114.713)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10705",
    "data-name": "Path 10705",
    d: "M560.326,200c-.048.082-3.572-1.588-7.877-3.737s-7.76-3.969-7.719-4.058,3.572,1.588,7.877,3.737S560.367,199.914,560.326,200Z",
    transform: "translate(-507.474 -107.206)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10706",
    "data-name": "Path 10706",
    d: "M574.165,141.823c.075-3.463.1-7.1.1-7.1s-4.441-.855-5.215-6.7c-.739-5.571,1.328-18.648,1.328-18.648h0c6.488-2.45,13.228-.226,17.67,5.03h0l-1.1,28.106a6.037,6.037,0,0,1-6.529,5.591h0A6.379,6.379,0,0,1,574.165,141.823Z",
    transform: "translate(-515.099 -80.745)",
    fill: "#e2b7a6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10707",
    "data-name": "Path 10707",
    d: "M570.56,124.784a.753.753,0,0,0,.684.773.719.719,0,0,0,.787-.684.746.746,0,0,0-.684-.766.684.684,0,0,0-.787.678Z",
    transform: "translate(-515.627 -85.708)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10708",
    "data-name": "Path 10708",
    d: "M570.154,123.325c.089.1.684-.308,1.471-.281s1.369.438,1.464.342-.041-.219-.294-.417a2.053,2.053,0,0,0-1.177-.39,1.923,1.923,0,0,0-1.17.342C570.2,123.106,570.106,123.277,570.154,123.325Z",
    transform: "translate(-515.495 -85.228)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10709",
    "data-name": "Path 10709",
    d: "M582.47,125.524a.746.746,0,0,0,.684.773.684.684,0,0,0,.787-.684.739.739,0,0,0-.684-.766.684.684,0,0,0-.787.678Z",
    transform: "translate(-519.387 -85.941)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10710",
    "data-name": "Path 10710",
    d: "M582.386,124.066c.089.1.684-.3,1.471-.281s1.369.438,1.471.342-.048-.219-.3-.411a1.964,1.964,0,0,0-1.17-.4,1.991,1.991,0,0,0-1.177.342C582.433,123.847,582.344,124.018,582.386,124.066Z",
    transform: "translate(-519.357 -85.461)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10711",
    "data-name": "Path 10711",
    d: "M576.978,129.919a5.175,5.175,0,0,0-1.3-.267c-.205,0-.4-.075-.424-.212a1,1,0,0,1,.151-.609l.643-1.54a26.764,26.764,0,0,0,1.471-4.051,27.12,27.12,0,0,0-1.793,3.921c-.212.541-.424,1.061-.623,1.553a1.2,1.2,0,0,0-.123.8.513.513,0,0,0,.329.315,1.4,1.4,0,0,0,.349.055A5.22,5.22,0,0,0,576.978,129.919Z",
    transform: "translate(-517.016 -85.437)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10712",
    "data-name": "Path 10712",
    d: "M576.74,146a14.822,14.822,0,0,0,7.843-1.882s-1.991,3.949-7.8,3.257Z",
    transform: "translate(-517.578 -92.027)",
    fill: "#d7a897"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10713",
    "data-name": "Path 10713",
    d: "M584.84,120.492c-.164.253-.78.144-1.464,0s-1.287-.26-1.369-.554.636-.684,1.553-.5S585,120.273,584.84,120.492Z",
    transform: "translate(-519.239 -84.221)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10714",
    "data-name": "Path 10714",
    d: "M573.1,119.008c-.062.294-.719.4-1.471.438s-1.417,0-1.506-.3.547-.725,1.458-.766S573.165,118.728,573.1,119.008Z",
    transform: "translate(-515.488 -83.901)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10715",
    "data-name": "Path 10715",
    d: "M577.7,135.793a.4.4,0,0,0-.445.205.45.45,0,1,0,.274-.226",
    transform: "translate(-517.722 -89.387)",
    fill: "#a36957"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10716",
    "data-name": "Path 10716",
    d: "M577.765,135.85c0-.034-.13-.233-.479-.157a.616.616,0,0,0-.438.431.656.656,0,0,0,1.013.725.575.575,0,0,0,.246-.568c-.068-.363-.335-.417-.349-.37s.1.171.075.383a.322.322,0,0,1-.164.253.349.349,0,0,1-.349,0,.363.363,0,0,1-.123-.335.335.335,0,0,1,.185-.253C577.574,135.843,577.745,135.9,577.765,135.85Z",
    transform: "translate(-517.604 -89.362)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10717",
    "data-name": "Path 10717",
    d: "M585.935,119.171c-.684,1.6-2.381,2.84-2.149,4.571.151,1.115.869,2.156.732,3.278-.178,1.369-1.636,2.382-1.848,3.784-.253,1.718,1.423,3.052,2.087,4.654.979,2.34-.267,4.968-.3,7.528a8.034,8.034,0,0,0,7.117,7.815,4.275,4.275,0,0,0,4.106-1.684c.684-1.109.534-2.518.931-3.743.6-1.834,2.347-3.175,2.737-5.064.684-3.422-3.49-6.3-3.216-9.8.116-1.5,1.04-2.8,1.43-4.25a6.242,6.242,0,0,0-1.218-5.536c-1.033-1.225-2.525-2.053-3.422-3.367-.992-1.512-1.027-3.422-1.369-5.208a13.126,13.126,0,0,0-20.845-7.685s-.992,4.51,3.641,5.269,6.775-.116,7.3,1.738a4.9,4.9,0,0,0,1.369,4.236C584.9,117.747,586.7,117.309,585.935,119.171Z",
    transform: "translate(-515.646 -78.651)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10718",
    "data-name": "Path 10718",
    d: "M600.212,156.26a1.636,1.636,0,0,1-.424-.041,6.689,6.689,0,0,1-1.177-.322,8.355,8.355,0,0,1-3.586-2.648,9.484,9.484,0,0,1-1.519-2.737,10.85,10.85,0,0,1-.623-3.511,14.5,14.5,0,0,1,.493-3.908,16.759,16.759,0,0,1,.684-1.978,20.193,20.193,0,0,0,.746-1.964,3.654,3.654,0,0,0,0-2.012,11.154,11.154,0,0,0-.773-1.875,12.313,12.313,0,0,1-.8-1.855,4,4,0,0,1-.144-1.964,13.931,13.931,0,0,1,1.519-3.223,6.1,6.1,0,0,0,.616-2.915,6.877,6.877,0,0,0-1.526-4.038,12.028,12.028,0,0,0-1.157-1.129,4.679,4.679,0,0,1,1.266,1.04,6.843,6.843,0,0,1,1.67,4.106,6.325,6.325,0,0,1-.6,3.052,14.13,14.13,0,0,0-1.465,3.155,5.839,5.839,0,0,0,.931,3.606,10.664,10.664,0,0,1,.807,1.937,4.03,4.03,0,0,1,0,2.19,21.429,21.429,0,0,1-.787,2.033,16.109,16.109,0,0,0-.684,1.937,14.106,14.106,0,0,0-.5,3.812,9.9,9.9,0,0,0,2.012,6.077,8.4,8.4,0,0,0,3.422,2.676C599.63,156.157,600.218,156.219,600.212,156.26Z",
    transform: "translate(-522.565 -84.458)",
    fill: "#455a64"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10719",
    "data-name": "Path 10719",
    d: "M593.356,116.87a4.837,4.837,0,0,1-1.02.151,10.613,10.613,0,0,1-2.82-.075,5.372,5.372,0,0,1-3.559-2.156,11.631,11.631,0,0,1-.931-2.3,3.819,3.819,0,0,0-1.56-1.923,11.028,11.028,0,0,0-4.79-1.252,8.356,8.356,0,0,1-3.99-1.246,3.949,3.949,0,0,1-1.636-2.279,2.292,2.292,0,0,1-.048-.773c0-.178.041-.267.055-.267a4.847,4.847,0,0,0,.13,1.006,3.914,3.914,0,0,0,1.642,2.108,8.273,8.273,0,0,0,3.88,1.122,11.162,11.162,0,0,1,4.955,1.28,4.161,4.161,0,0,1,1.7,2.1,11.453,11.453,0,0,0,.883,2.245,5.166,5.166,0,0,0,3.326,2.053,11.812,11.812,0,0,0,2.737.185A6.92,6.92,0,0,1,593.356,116.87Z",
    transform: "translate(-516.395 -79.6)",
    fill: "#455a64"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10720",
    "data-name": "Path 10720",
    d: "M592.229,110.908a2.279,2.279,0,0,1-.8.116,4.879,4.879,0,0,1-3.422-1.369,6.281,6.281,0,0,1-1.061-1.417c-.616-1.04-1.211-2.32-2.491-2.854a8.213,8.213,0,0,0-3.832-.335,11.758,11.758,0,0,1-3.271,0,4.106,4.106,0,0,1-2.053-.9,2.273,2.273,0,0,1-.4-.452q-.123-.178-.1-.185a4.567,4.567,0,0,0,.589.527,4.311,4.311,0,0,0,1.978.766,12.413,12.413,0,0,0,3.2-.055,8.213,8.213,0,0,1,4,.342,3.935,3.935,0,0,1,1.636,1.369,17.647,17.647,0,0,1,.992,1.656,6.512,6.512,0,0,0,.992,1.369,4.79,4.79,0,0,0,1.17.869,5.078,5.078,0,0,0,2.053.568A5.276,5.276,0,0,1,592.229,110.908Z",
    transform: "translate(-516.964 -79.209)",
    fill: "#455a64"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10721",
    "data-name": "Path 10721",
    d: "M604.5,155.672c-.034,0,.185-.452.438-1.3a11.771,11.771,0,0,0,.452-3.668,11.169,11.169,0,0,0-1.458-5.222c-.5-.9-1.259-1.7-1.882-2.683a4.791,4.791,0,0,1-.684-1.649,3.688,3.688,0,0,1,.151-1.848,21.946,21.946,0,0,0,1.218-3.264,4.73,4.73,0,0,0-.89-2.963,14.585,14.585,0,0,1-.732-1.369,5,5,0,0,1-.39-1.43,12.4,12.4,0,0,1,.082-2.607,6.919,6.919,0,0,0-.328-3.641,3.314,3.314,0,0,0-.807-1.068.142.142,0,0,1,.082.041.836.836,0,0,1,.219.157,2.443,2.443,0,0,1,.637.814,6.761,6.761,0,0,1,.445,3.716,13.12,13.12,0,0,0-.034,2.553,6.571,6.571,0,0,0,1.109,2.655,9.1,9.1,0,0,1,.746,1.458,3.42,3.42,0,0,1,.205,1.725,20.152,20.152,0,0,1-1.225,3.326,3.421,3.421,0,0,0-.144,1.677,4.555,4.555,0,0,0,.643,1.526c.582.951,1.369,1.766,1.868,2.7a11.292,11.292,0,0,1,1.424,5.386,11.075,11.075,0,0,1-.575,3.716,7.123,7.123,0,0,1-.4.944A1.255,1.255,0,0,1,604.5,155.672Z",
    transform: "translate(-524.816 -85.348)",
    fill: "#455a64"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10722",
    "data-name": "Path 10722",
    d: "M563.746,314.133s-4.612-43.689-4.879-59.833,7.261-32.075,7.261-32.075L595.609,221s5.831,16.376,5.933,23.268c.205,13.372-3.552,26.573-3.121,37.181l.985,32.712",
    transform: "translate(-511.934 -116.295)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10723",
    "data-name": "Path 10723",
    d: "M602.183,278.6a4.723,4.723,0,0,1-.486.37l-.267.185-.287.281a4.727,4.727,0,0,0-.684.732c-.951,1.163-1.643,3.251-2.306,5.844a19.637,19.637,0,0,1-1.492,4.161,7.285,7.285,0,0,1-.684,1.033c-.123.164-.24.342-.383.5l-.452.452a7.33,7.33,0,0,1-2.217,1.423c-1.649.725-3.518,1.068-5.215,1.923a8.212,8.212,0,0,0-3.784,4.311c-.835,1.855-1.369,3.8-2.053,5.618a10.128,10.128,0,0,1-3.08,4.667,8.458,8.458,0,0,1-4.79,1.512c-1.588.1-3.059.048-4.38.246a6.919,6.919,0,0,0-3.3,1.245,4.627,4.627,0,0,0-1.533,2.163,3.285,3.285,0,0,0-.116,1.677c.082.383.185.568.164.575a1.726,1.726,0,0,1-.233-.561,3.143,3.143,0,0,1,.055-1.731,4.654,4.654,0,0,1,1.54-2.279,7.014,7.014,0,0,1,3.422-1.369c1.369-.219,2.826-.192,4.393-.294a8.212,8.212,0,0,0,4.647-1.478,9.937,9.937,0,0,0,2.949-4.53c.684-1.8,1.184-3.75,2.053-5.639a8.555,8.555,0,0,1,3.956-4.482c1.766-.876,3.634-1.211,5.242-1.909A7.178,7.178,0,0,0,595,291.876l.431-.431c.137-.151.253-.322.376-.479a6.6,6.6,0,0,0,.636-.992,19.625,19.625,0,0,0,1.512-4.106c.684-2.587,1.43-4.7,2.436-5.872a4.455,4.455,0,0,1,.684-.725c.109-.1.205-.192.3-.267l.281-.178a4.742,4.742,0,0,1,.527-.226Z",
    transform: "translate(-513.718 -134.476)",
    fill: "#fafafa"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10724",
    "data-name": "Path 10724",
    d: "M601.08,249.06a3.207,3.207,0,0,1,.041.582,7.183,7.183,0,0,1-.205,1.677,10.778,10.778,0,0,1-3.333,5.146,19.8,19.8,0,0,1-3.422,2.525c-1.321.78-2.778,1.526-4.277,2.375a22.1,22.1,0,0,0-4.366,3.073,16.865,16.865,0,0,0-3.312,4.647,42.5,42.5,0,0,1-2.867,5.057,12.084,12.084,0,0,1-1.875,2.053,11.317,11.317,0,0,1-2.265,1.5,27.305,27.305,0,0,1-4.578,1.759,41.059,41.059,0,0,0-4.024,1.369,15.41,15.41,0,0,0-3.066,1.642,9.493,9.493,0,0,0-1.923,1.772,8.8,8.8,0,0,0-1.157,1.916,3.621,3.621,0,0,1,.192-.554,6.847,6.847,0,0,1,.855-1.451,9.219,9.219,0,0,1,1.916-1.848,15.622,15.622,0,0,1,3.086-1.711,41.072,41.072,0,0,1,4.031-1.4,28.315,28.315,0,0,0,4.517-1.766,11.669,11.669,0,0,0,2.156-1.451,12.141,12.141,0,0,0,1.807-2.012,44.046,44.046,0,0,0,2.84-5.023,16.99,16.99,0,0,1,3.422-4.736,22.055,22.055,0,0,1,4.448-3.107c1.505-.842,2.963-1.574,4.284-2.347a19.756,19.756,0,0,0,3.422-2.45,10.854,10.854,0,0,0,3.367-5A10.463,10.463,0,0,0,601.08,249.06Z",
    transform: "translate(-512.436 -125.152)",
    fill: "#fafafa"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10725",
    "data-name": "Path 10725",
    d: "M558.968,256.469a.515.515,0,0,1-.062-.137,3.575,3.575,0,0,1-.13-.4,3.273,3.273,0,0,1,.068-1.642,6.78,6.78,0,0,1,4.332-4c1.218-.417,2.594-.684,4.031-1.04a7.59,7.59,0,0,0,5.577-4.154,22.006,22.006,0,0,0,1.02-2.457,26.779,26.779,0,0,1,2.169-5.249,8.362,8.362,0,0,1,4.462-3.47,40.518,40.518,0,0,1,5.126-1.3,16.992,16.992,0,0,0,4.455-1.519,9.375,9.375,0,0,0,3.011-2.737,10.182,10.182,0,0,0,1.916-5.543,15.727,15.727,0,0,0-.144-2.19,7.122,7.122,0,0,1,.281,2.19,10.08,10.08,0,0,1-1.848,5.687,9.471,9.471,0,0,1-3.073,2.826,17.062,17.062,0,0,1-4.523,1.581,40.768,40.768,0,0,0-5.078,1.307,8.034,8.034,0,0,0-4.284,3.333,26.834,26.834,0,0,0-2.142,5.174,21.293,21.293,0,0,1-1.047,2.5,9.035,9.035,0,0,1-1.533,2.121,8.9,8.9,0,0,1-4.277,2.156c-1.451.37-2.82.6-4.017,1a6.63,6.63,0,0,0-4.284,3.8,3.469,3.469,0,0,0-.13,1.588,3.423,3.423,0,0,1,.123.582Z",
    transform: "translate(-511.885 -116.178)",
    fill: "#fafafa"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10726",
    "data-name": "Path 10726",
    d: "M600.3,327a2.624,2.624,0,0,1,.048.431,4.54,4.54,0,0,1-.13,1.232,6.987,6.987,0,0,1-2.587,3.7,11.409,11.409,0,0,1-2.737,1.615c-1.047.445-2.2.8-3.422,1.177a28.282,28.282,0,0,0-3.7,1.369,10.575,10.575,0,0,0-3.292,2.457c-1,1.04-1.861,2.183-2.819,3.2a12.843,12.843,0,0,1-3.155,2.464,13.9,13.9,0,0,1-6.508,1.7,12.961,12.961,0,0,1-4.476-.746,8.537,8.537,0,0,1-1.136-.486,1.8,1.8,0,0,1-.376-.212,2.89,2.89,0,0,1,.4.144,12.121,12.121,0,0,0,1.15.424,13.687,13.687,0,0,0,4.435.623,13.831,13.831,0,0,0,6.351-1.731,12.784,12.784,0,0,0,3.059-2.416c.938-1,1.793-2.135,2.813-3.2A10.991,10.991,0,0,1,587.7,336.2a28.329,28.329,0,0,1,3.757-1.369,35.812,35.812,0,0,0,3.422-1.136,11.477,11.477,0,0,0,2.669-1.54,6.981,6.981,0,0,0,2.607-3.531A8.7,8.7,0,0,0,600.3,327Z",
    transform: "translate(-514.191 -149.754)",
    fill: "#fafafa"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10727",
    "data-name": "Path 10727",
    d: "M597.643,178.63l-5.707.137A9.231,9.231,0,0,1,590.649,182a97.548,97.548,0,0,1-9.382-23.822c.137-.445.294-.938.493-1.485a6.323,6.323,0,0,0-.075-2.5c-.164-.992-.438-2.327-.52-2.943-.253-1.889-.561-2.183-1.218-1.971-.89.294.37,5.29-.363,5.4-.4.055-.876-1.656-1.013-3.059s-.78-5.728-1.239-6.015c-.684-.424-1.28.246-1.1,1.642s.39,5.639-.349,5.7-1.369-7.11-1.369-7.11.116-1.56-.746-1.526c-1.547.068-.335,7.624-.205,8.342.1.493-.684.589-.78.048s-.452-7.165-2.053-7.11c-1.218,0,.938,6.221.253,7.658s-1.15-4.873-2.306-4.79c-.431.034-.753.116.041,3.682a80.877,80.877,0,0,0,2.737,8.356c1.834,9.889,9.882,41.526,22.495,35.737,7.062-3.244,9.923-17.6,9.923-17.6Z",
    transform: "translate(-514.892 -92.087)",
    fill: "#e2b7a6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10728",
    "data-name": "Path 10728",
    d: "M575.584,153.116a.335.335,0,0,0,.164,0,.363.363,0,0,0,.253-.4c0-.424-.082-1.04-.178-1.841a25.7,25.7,0,0,1-.315-2.915c0-.575,0-1.191.034-1.841a6.784,6.784,0,0,1,.1-.985c.055-.308.26-.684.5-.623h.041a.547.547,0,0,1,.506.465,2.685,2.685,0,0,1,.1.917h0a53.388,53.388,0,0,0,.732,5.714c.055.253.109.513.192.773a2.938,2.938,0,0,0,.137.39,2.172,2.172,0,0,0,.116.205.376.376,0,0,0,.287.178.506.506,0,0,0,.431-.363,1.961,1.961,0,0,0,.13-.417,6.973,6.973,0,0,0,.109-.835,24.932,24.932,0,0,0-.048-3.422,7.733,7.733,0,0,1-.068-1.718.958.958,0,0,1,.335-.636.362.362,0,0,1,.294-.034.562.562,0,0,1,.164.068.219.219,0,0,1,.075.1,8.722,8.722,0,0,1,.472,1.718c.123.6.226,1.225.322,1.848s.185,1.252.26,1.889a13.935,13.935,0,0,0,.315,1.95,7.546,7.546,0,0,0,.308.965,1.817,1.817,0,0,0,.287.486.4.4,0,0,0,.4.151.424.424,0,0,0,.281-.308,3.425,3.425,0,0,0,.075-1.068,9.818,9.818,0,0,0-.075-1.013c-.048-.575-.1-1.143-.123-1.7a6.634,6.634,0,0,1,0-.828,1.369,1.369,0,0,1,.089-.356.335.335,0,0,1,.062-.1h.089c.452-.185.6.445.725.951s.171,1.081.281,1.622c.178,1.074.411,2.149.527,3.175a3.783,3.783,0,0,1-.055,1.478c-.164.493-.328.979-.486,1.465v.089a78.815,78.815,0,0,0,3.059,9.9c1.081,2.922,2.169,5.475,3.12,7.528s1.814,3.661,2.4,4.743l.684,1.225a2.3,2.3,0,0,0,.267.411,2.744,2.744,0,0,0-.212-.438l-.684-1.252c-.561-1.1-1.369-2.737-2.3-4.79s-1.985-4.606-3.039-7.528a81.726,81.726,0,0,1-3-9.868v.1c.157-.479.315-.965.479-1.451a3.916,3.916,0,0,0,.082-1.636c-.123-1.074-.349-2.115-.527-3.2-.1-.534-.171-1.081-.281-1.642a3.01,3.01,0,0,0-.144-.849.807.807,0,0,0-.376-.383.869.869,0,0,0-.541,0h-.109a.444.444,0,0,0-.157.089.6.6,0,0,0-.171.24,1.548,1.548,0,0,0-.116.465,6.469,6.469,0,0,0,0,.89c0,.575.082,1.15.13,1.725,0,.335.055.684.068.992a3.327,3.327,0,0,1-.048.924c0,.068-.055.055,0,.089h0l-.041-.041a1.371,1.371,0,0,1-.205-.37,6.734,6.734,0,0,1-.294-.91,12.722,12.722,0,0,1-.308-1.9q-.109-.965-.267-1.909c-.1-.63-.205-1.246-.328-1.861a8.335,8.335,0,0,0-.52-1.827.582.582,0,0,0-.212-.24,1.182,1.182,0,0,0-.253-.11.76.76,0,0,0-.582.082,1.28,1.28,0,0,0-.506.89,3.323,3.323,0,0,0,0,.938c0,.294.068.582.089.869a25.324,25.324,0,0,1,.062,3.367,5.83,5.83,0,0,1-.1.794,1.527,1.527,0,0,1-.1.356.415.415,0,0,1-.075.123c0,.062-.048,0-.041.082v-.089a1.382,1.382,0,0,1-.082-.144c-.048-.109-.089-.233-.13-.349-.075-.246-.13-.5-.185-.746a54.375,54.375,0,0,1-.773-5.666h0a2.977,2.977,0,0,0-.116-1.02.958.958,0,0,0-.267-.452.684.684,0,0,0-.506-.192h.041a.6.6,0,0,0-.6.281,1.51,1.51,0,0,0-.205.534,6.907,6.907,0,0,0-.1,1.027v1.861a23.892,23.892,0,0,0,.376,2.929c.116.794.205,1.41.246,1.827a.322.322,0,0,1-.2.356A1.033,1.033,0,0,0,575.584,153.116Z",
    transform: "translate(-517.162 -92.072)",
    fill: "#d7a897"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10729",
    "data-name": "Path 10729",
    d: "M504.141,208.228a14.653,14.653,0,0,0-3.962.459c-3.538.931-9.636,4.626-9.889,9.191h4.435s-2.484,5.283-1.759,4.79a56.972,56.972,0,0,0,5.66-5.1Z",
    transform: "translate(-490.29 -112.262)",
    fill: "#e2b7a6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10730",
    "data-name": "Path 10730",
    d: "M598.184,84.424c-.1,0-.5-3.654-.9-8.212S596.645,68,596.74,68s.5,3.654.9,8.212S598.28,84.424,598.184,84.424Z",
    transform: "translate(-523.885 -68)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10731",
    "data-name": "Path 10731",
    d: "M620.966,68.41c.075.055-2.915,4.4-6.686,9.7s-6.9,9.581-6.98,9.5,2.915-4.4,6.686-9.7S620.884,68.355,620.966,68.41Z",
    transform: "translate(-527.224 -68.129)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10732",
    "data-name": "Path 10732",
    d: "M631.838,97.186c0,.1-3.477.9-7.8,1.786s-7.856,1.533-7.877,1.437,3.47-.9,7.8-1.786S631.79,97.09,631.838,97.186Z",
    transform: "translate(-530.021 -77.21)",
    fill: "#263238"
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Folder--inject-1",
    transform: "translate(145.384 128.801)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_10733",
    "data-name": "Path 10733",
    d: "M286.374,230.673,262.148,355.088,259,371.375l161.506-.78c7.254-.034,13.687-6.474,16.007-16.041L465.16,237.1c1.772-7.261-2.115-14.816-7.617-14.809l-163.5.171C290.48,222.454,287.291,225.821,286.374,230.673Z",
    transform: "translate(-199.888 -198.967)",
    fill: "#4eb6ee"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_2519",
    "data-name": "Group 2519",
    transform: "translate(59.113 23.323)",
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_10734",
    "data-name": "Path 10734",
    d: "M286.374,230.673,262.148,355.088,259,371.375l161.506-.78c7.254-.034,13.687-6.474,16.007-16.041L465.16,237.1c1.772-7.261-2.115-14.816-7.617-14.809l-163.5.171C290.48,222.454,287.291,225.821,286.374,230.673Z",
    transform: "translate(-259 -222.29)"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_10735",
    "data-name": "Path 10735",
    d: "M377.767,335.885,360.659,198.051a10.828,10.828,0,0,0-10.512-9.841l-37.5.116a10.265,10.265,0,0,0-7.411,3.285L287.44,210.547l-104.295.561c-6.371.034-11.271,6.07-10.429,12.845L188.6,351.345a10.843,10.843,0,0,0,10.5,9.841l181.8-.363c20.243.417,22.18-5.557,22.18-5.557C379.834,360.405,377.767,335.919,377.767,335.885Z",
    transform: "translate(-172.622 -188.21)",
    fill: "#4eb6ee"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_2520",
    "data-name": "Group 2520",
    transform: "translate(73.402 76.168)",
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_10736",
    "data-name": "Path 10736",
    d: "M333.232,344.124l-6.132,6.583-47.22-42.484,6.132-6.583Z",
    transform: "translate(-279.88 -300.182)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10737",
    "data-name": "Path 10737",
    d: "M325.421,299.51l6.775,6.1-42.724,45.885-6.782-6.1Z",
    transform: "translate(-280.767 -299.51)",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--speech-bubble--inject-1",
    transform: "translate(354.402 39.793)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_10738",
    "data-name": "Path 10738",
    d: "M507.732,95.166a1.266,1.266,0,0,1-.773-1.115l-.274-6.351a1.273,1.273,0,0,1,1.567-1.3,3.983,3.983,0,0,0,3.093-.609,3.566,3.566,0,0,0,1.595-2.34,3.647,3.647,0,0,0-.767-2.737,4.106,4.106,0,0,0-2.7-1.622,4.79,4.79,0,0,0-4.859,3.422,1.28,1.28,0,0,1-2.464-.684,7.363,7.363,0,0,1,7.617-5.317,6.611,6.611,0,0,1,4.441,2.621,6.248,6.248,0,0,1,1.252,4.7,6.159,6.159,0,0,1-2.737,4.051,6.652,6.652,0,0,1-3.463,1.129l.212,4.9a1.28,1.28,0,0,1-1.779,1.225Z",
    transform: "translate(-485.648 -63.938)",
    fill: "#4eb6ee"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10739",
    "data-name": "Path 10739",
    d: "M512.1,107.13a1.04,1.04,0,1,1-.355-.719A1.047,1.047,0,0,1,512.1,107.13Z",
    transform: "translate(-488.136 -73.302)",
    fill: "#5e98ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10740",
    "data-name": "Path 10740",
    d: "M478.146,80.418a3.224,3.224,0,0,0,.062-.411c0-.3.075-.684.13-1.225a14.827,14.827,0,0,1,.335-1.971c.089-.383.137-.808.274-1.239s.274-.9.424-1.369a23.6,23.6,0,0,1,3.422-6.522,22.927,22.927,0,0,1,7.192-6.255,22.585,22.585,0,0,1,5.071-2.094,22.96,22.96,0,0,1,5.851-.766,22.691,22.691,0,0,1,3.114.164c.527.055,1.047.192,1.574.281a11.717,11.717,0,0,1,1.574.383,21.9,21.9,0,0,1,6.084,2.758,22.885,22.885,0,0,1,9.047,11.36,22.407,22.407,0,0,1,1.369,7.808,22.007,22.007,0,0,1-1.43,8.034l-.308.78-.041.1.041.1c1.718,3.949,3.422,7.829,5.03,11.586l.287-.328-10.265-3.935-.123-.048-.1.1a22.565,22.565,0,0,1-28.154,2.717,23.386,23.386,0,0,1-5.769-5.372,22.727,22.727,0,0,1-4.38-10.5c-.082-.684-.151-1.259-.212-1.779s0-.944-.034-1.307a6.1,6.1,0,0,1,0-.8.137.137,0,1,0-.041,0v2.121c0,.52.116,1.115.185,1.793a24.485,24.485,0,0,0,1.17,4.831,25.056,25.056,0,0,0,3.134,5.817,23.59,23.59,0,0,0,5.81,5.475,22.789,22.789,0,0,0,28.558-2.642l-.226.048,10.265,3.956.513.2-.226-.527c-1.629-3.757-3.312-7.63-5.023-11.586v.2l.315-.8a22.378,22.378,0,0,0,1.464-8.212,22.891,22.891,0,0,0-1.369-7.979,23.268,23.268,0,0,0-9.245-11.572,22.106,22.106,0,0,0-6.241-2.806,10.877,10.877,0,0,0-1.6-.376c-.534-.1-1.061-.233-1.595-.281a23.535,23.535,0,0,0-3.155-.178,22.967,22.967,0,0,0-5.94.808,23.4,23.4,0,0,0-5.139,2.149,22.973,22.973,0,0,0-7.234,6.4,23.4,23.4,0,0,0-3.374,6.624c-.144.493-.281.965-.4,1.369a12.041,12.041,0,0,0-.26,1.252,13.011,13.011,0,0,0-.287,1.985c-.041.527-.068.931-.089,1.232A1.735,1.735,0,0,0,478.146,80.418Z",
    transform: "translate(-478.05 -58.148)",
    fill: "#263238"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNodata);
export default __webpack_public_path__ + "static/media/Nodata.3076e3cf4a5826ee4db4eda7f4a8f2ce.svg";
export { ForwardRef as ReactComponent };